import { Lightbulb } from "lucide-react";
import { useI18n } from "@/i18n";

/**
 * Decorative "example" hint shown below the content of a section.
 * Translates automatically with the current UI language. The `slug` resolves to
 * three i18n keys: `hint_<slug>_title`, `hint_<slug>_1`, `hint_<slug>_2`,
 * `hint_<slug>_3` — each of which can contain `<strong>` markup.
 *
 * Usage: <ExampleHint slug="vault" />
 */
export default function ExampleHint({ slug, testid }) {
  const { t } = useI18n();
  const paragraphs = ["1", "2", "3"]
    .map((n) => t(`hint_${slug}_${n}`))
    .filter((s) => s && s !== `hint_${slug}_${"1234".charAt(0)}` && !s.startsWith("hint_"));

  return (
    <div
      className="mt-10 mb-2 max-w-2xl rounded-md p-5 sm:p-6 border border-gold-subtle/40 bg-gradient-to-br from-obsidian-2/30 to-transparent backdrop-blur-sm"
      data-testid={testid || `hint-${slug}`}
    >
      <div className="flex items-center gap-2 mb-3">
        <Lightbulb className="w-4 h-4 text-gold/80" strokeWidth={1.4} />
        <span className="font-label text-faded text-xs tracking-[0.18em]">
          {t(`hint_${slug}_title`)}
        </span>
      </div>
      <div className="text-sm text-muted leading-relaxed space-y-2 [&_strong]:text-gold-light">
        {paragraphs.map((p, i) => (
          <p key={i} dangerouslySetInnerHTML={{ __html: p }} />
        ))}
      </div>
    </div>
  );
}
